import React from 'react'

const ContentBoxHeader = ({ children }) => {
    return (<div className="content-box-header">{children}</div>)
}

export default ContentBoxHeader



// WEBPACK FOOTER //
// ./src/modules/layout/component/ContentBoxHeader.js